import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AnimatePresence, motion } from 'framer-motion';
import * as XLSX from 'xlsx';
import {
  FiCheck,
  FiEye,
  FiAlertCircle,
  FiPhone,
  FiHash,
  FiUser,
  FiFileText,
  FiClock,
  FiFilter,
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiCalendar,
  FiGlobe,
  FiTrendingUp,
  FiTrendingDown,
  FiMinus,
  FiCheckCircle,
  FiBarChart2,
  FiX,
  FiChevronDown,
  FiChevronRight,
  FiAlertTriangle,
} from 'react-icons/fi';
import api from '../../api';

import DemandeDetail from './DemandeDetail';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_BASE = '/demandes';

const DemandeList = ({ isNavbarOpen }) => {
  const [demandes, setDemandes] = useState([]);
  const [filteredDemandes, setFilteredDemandes] = useState([]);
  const [joursMap, setJoursMap] = useState({});
  const [selectionnee, setSelectionnee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [sortBy, setSortBy] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    validated: 0,
    avgDays: 0,
    growth: {
      total: 0,
      pending: 0,
      validated: 0,
      avgDays: 0
    },
    currentMonthStats: {},
    previousMonthStats: {}
  });
    const [chefIdRaw, setChefIdRaw] = useState(null);

      useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setChefIdRaw(parseInt(user.id, 10));

      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);
  const chefId = chefIdRaw ? parseInt(chefIdRaw, 10) : null;
  const [showReturnModal, setShowReturnModal] = useState(false);
const [causeText, setCauseText] = useState('');
const [isProcessing, setIsProcessing] = useState(false);
const [selectedDemande, setSelectedDemande] = useState(null);

  // Fonction pour calculer les statistiques dynamiquement
  const calculateDynamicStats = (allDemandes) => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0-11
    const currentYear = now.getFullYear();
    
    // Mois précédent
    const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const previousYear = currentMonth === 0 ? currentYear - 1 : currentYear;

    // Filtrer les demandes du mois actuel
    const demandesCeMois = allDemandes.filter(d => {
      const createdAt = new Date(d.created_at);
      return createdAt.getMonth() === currentMonth && createdAt.getFullYear() === currentYear;
    });

    // Filtrer les demandes du mois précédent
    const demandesMoisPrecedent = allDemandes.filter(d => {
      const createdAt = new Date(d.created_at);
      return createdAt.getMonth() === previousMonth && createdAt.getFullYear() === previousYear;
    });

    // Statistiques pour tous les temps
    const statsAllTime = {
      total: allDemandes.length,
      pending: allDemandes.filter(d => d.confirmation_admin === 0 && d.accepter === '3').length,
      validated: allDemandes.filter(d => d.confirmation_admin === 1 || d.accepter === '1').length,
      rejected: allDemandes.filter(d => d.accepter === '2').length,
      avgDays: 0
    };

    // Calcul de la moyenne des jours pour tous les temps
    const avecJoursAllTime = allDemandes.filter(d => d.nbr_jrs !== null && !isNaN(d.nbr_jrs) && d.nbr_jrs > 0);
    if (avecJoursAllTime.length > 0) {
      statsAllTime.avgDays = Math.round(
        avecJoursAllTime.reduce((acc, d) => acc + d.nbr_jrs, 0) / avecJoursAllTime.length
      );
    }

    // Statistiques du mois actuel
    const statsCeMois = {
      total: demandesCeMois.length,
      pending: demandesCeMois.filter(d => d.confirmation_admin === 0 && d.accepter === '3').length,
      validated: demandesCeMois.filter(d => d.confirmation_admin === 1 || d.accepter === '1').length,
      rejected: demandesCeMois.filter(d => d.accepter === '2').length,
      avgDays: 0
    };

    // Calcul de la moyenne des jours pour ce mois
    const avecJoursCeMois = demandesCeMois.filter(d => d.nbr_jrs !== null && !isNaN(d.nbr_jrs) && d.nbr_jrs > 0);
    if (avecJoursCeMois.length > 0) {
      statsCeMois.avgDays = Math.round(
        avecJoursCeMois.reduce((acc, d) => acc + d.nbr_jrs, 0) / avecJoursCeMois.length
      );
    }

    // Statistiques du mois précédent
    const statsMoisPrecedent = {
      total: demandesMoisPrecedent.length,
      pending: demandesMoisPrecedent.filter(d => d.confirmation_admin === 0 && d.accepter === '3').length,
      validated: demandesMoisPrecedent.filter(d => d.confirmation_admin === 1 || d.accepter === '1').length,
      rejected: demandesMoisPrecedent.filter(d => d.accepter === '2').length,
      avgDays: 0
    };

    // Calcul de la moyenne des jours pour le mois précédent
    const avecJoursMoisPrecedent = demandesMoisPrecedent.filter(d => d.nbr_jrs !== null && !isNaN(d.nbr_jrs) && d.nbr_jrs > 0);
    if (avecJoursMoisPrecedent.length > 0) {
      statsMoisPrecedent.avgDays = Math.round(
        avecJoursMoisPrecedent.reduce((acc, d) => acc + d.nbr_jrs, 0) / avecJoursMoisPrecedent.length
      );
    }

    // Calcul des pourcentages de croissance
    const calculateGrowthPercentage = (current, previous) => {
      if (previous === 0) {
        return current > 0 ? 100 : 0; // Si pas de données le mois précédent
      }
      return Math.round(((current - previous) / previous) * 100);
    };

    // Pourcentages de croissance
    const growthStats = {
      total: calculateGrowthPercentage(statsCeMois.total, statsMoisPrecedent.total),
      pending: calculateGrowthPercentage(statsCeMois.pending, statsMoisPrecedent.pending),
      validated: calculateGrowthPercentage(statsCeMois.validated, statsMoisPrecedent.validated),
      avgDays: calculateGrowthPercentage(statsCeMois.avgDays, statsMoisPrecedent.avgDays)
    };

    return {
      allTime: statsAllTime,
      currentMonth: statsCeMois,
      previousMonth: statsMoisPrecedent,
      growth: growthStats
    };
  };

  // Fonction pour formater l'affichage du pourcentage de croissance
  const formatGrowthDisplay = (percentage) => {
    if (percentage > 0) {
      return {
        value: `+${percentage}%`,
        color: 'text-green-500',
        icon: FiTrendingUp
      };
    } else if (percentage < 0) {
      return {
        value: `${percentage}%`,
        color: 'text-red-500',
        icon: FiTrendingDown
      };
    } else {
      return {
        value: '0%',
        color: 'text-gray-500',
        icon: FiMinus
      };
    }
  };

  // Fonction pour obtenir le nom du mois
  const getMonthName = (monthIndex) => {
    const months = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
    return months[monthIndex];
  };

  const refreshData = async () => {
    try {
      setLoading(true);
      const data = await fetchDemandes(); 
      setDemandes(data);
      setFilteredDemandes(data);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDemandes = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get(API_BASE);
      const filteredData = data.demandes.filter(
        d => Number(d.demandes?.accepter) === Number(3) && Number(d.demandes?.confirmation_admin) === Number(0)
      );
      const allDemandes = data.demandes;
      setDemandes(allDemandes);
      setFilteredDemandes(filteredData);

      // Calcul des statistiques dynamiques
      const dynamicStats = calculateDynamicStats(allDemandes);
      
      // Mise à jour de l'état avec les nouvelles statistiques
      setStats({
        // Utiliser les stats de tous les temps pour l'affichage principal
        total: dynamicStats.allTime.total,
        pending: dynamicStats.allTime.pending,
        validated: dynamicStats.allTime.validated,
        avgDays: dynamicStats.allTime.avgDays,
        
        // Données de croissance basées sur les comparaisons mensuelles
        growth: dynamicStats.growth,
        currentMonthStats: dynamicStats.currentMonth,
        previousMonthStats: dynamicStats.previousMonth
      });

    } catch {
      const msg = 'Impossible de charger les demandes';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDemandes();
  }, []);

  // Filtrage et recherche
  useEffect(() => {
    // Étape 1 : base à afficher = demandes en attente (confirmation_admin === 0 et accepter === '1')
    let baseFiltered = demandes.filter(d => d.confirmation_admin === 0 && d.accepter === '3');

    // Étape 2 : recherche
    if (searchTerm) {
      baseFiltered = baseFiltered.filter(d =>
        d.ticket.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.ticket.organisation.nomOrganisation.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.id.toString().includes(searchTerm)
      );
    }

    // Étape 3 : tri
    baseFiltered.sort((a, b) => {
      let aValue, bValue;
      switch (sortBy) {
        case 'client':
          aValue = a.ticket.organisation.nomOrganisation;
          bValue = b.ticket.organisation.nomOrganisation;
          break;
        case 'demande':
          aValue = a.ticket.nom;
          bValue = b.ticket.nom;
          break;
        case 'jours':
          aValue = a.nbr_jrs || 0;
          bValue = b.nbr_jrs || 0;
          break;
        default:
          aValue = a.id;
          bValue = b.id;
      }

      if (typeof aValue === 'string') {
        return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }
      return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });

    // Étape 4 : appliquer à l'état
    setFilteredDemandes(baseFiltered);
  }, [demandes, searchTerm, sortBy, sortOrder]);

  const handleChangeJours = (id, val) => {
    setJoursMap(prev => ({ ...prev, [id]: val }));
  };

  const updateDemande = async (d, updates) => {
    setError(null);
    if (!chefId) {
      const msg = "Identifiant de projet invalide";
      setError(msg);
      toast.error(msg);
      return;
    }

    const payload = {
      ...updates,
      chef_de_projet_id: chefId,
    };

    try {
      await api.post(`${API_BASE}/${d.id}`, payload);
      toast.success('Demande validée avec succès', {
        position: 'top-right',
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        icon: '✅'
      });
      fetchDemandes();
      setJoursMap(prev => {
        const next = { ...prev };
        delete next[d.id];
        return next;
      });
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur lors de la validation';
      console.error('Erreur mise à jour:', err.response?.data);
      setError(msg);
      toast.error(msg);
    }
  };

  const handleValider = d => {
    const joursValider = Number(joursMap[d.id] || d.nbr_jrs || 0);
    if (joursValider <= 0) {
      toast.warning('Veuillez saisir un nombre de jours valide');
      return;
    }
    updateDemande(d, { nbr_jrs: joursValider, confirmation_admin: '0' ,  accepter: '1' });
  };



// const handleRefuser = async (d) => {  // Add parameter to receive the demande object
//   try {
//     await updateDemande(d, {  // Pass the demande object and updates
//       accepter: '2', 
//     });
    
//     toast.success('Demande refusée avec succès');
//   } catch (error) {
//     toast.error('Erreur lors du refus de la demande');
//     console.error('Erreur:', error);
//   }
// };
const handleRefuser = (d) => {
  setSelectedDemande(d);
  setShowReturnModal(true);
};
const handleConfirmReject = async () => {
  if (!causeText.trim() || !selectedDemande) return;
  
  setIsProcessing(true);
  try {
    await updateDemande(selectedDemande, { 
      accepter: '2',
      cause_reject: causeText 
    });
    
    toast.success('Demande refusée avec succès');
    setShowReturnModal(false);
    setCauseText('');
  } catch (error) {
    toast.error('Erreur lors du refus de la demande');
    console.error('Erreur:', error);
  } finally {
    setIsProcessing(false);
  }
};
  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('asc');
    }
  };

  // Fonction d'export Excel (inchangée)
  const handleExportExcel = async () => {
    setExporting(true);
    try {
      const exportData = filteredDemandes.map((demande, index) => ({
        'N°': index + 1,
        'ID Demande': demande.id,
        'Organisation Cliente': demande.ticket.organisation.nomOrganisation,
        'Description de la Demande': demande.ticket.nom,
        'Jours Demandés': demande.nbr_jrs || 0,
        'Jours Validés': joursMap[demande.id] || demande.nbr_jrs || 0,
        'Statut': demande.accepter === '3' ? 'En attente' : demande.accepter === '1' ? 'Validé' : 'Refusé',
        'Confirmation Admin': demande.confirmation_admin === '0' ? 'Non' : 'Oui',
        'Date de Création': demande.created_at ? new Date(demande.created_at).toLocaleDateString('fr-FR') : 'N/A',
        'Type de Ticket': demande.ticket.type || 'Standard',
        'Priorité': demande.ticket.priorite || 'Normale'
      }));

      const statsData = [
        { 'Indicateur': 'Total des demandes', 'Valeur': stats.total },
        { 'Indicateur': 'Demandes en attente', 'Valeur': stats.pending },
        { 'Indicateur': 'Demandes validées', 'Valeur': stats.validated },
        { 'Indicateur': 'Moyenne de jours par demande', 'Valeur': stats.avgDays },
        { 'Indicateur': 'Taux de validation', 'Valeur': `${stats.total > 0 ? Math.round((stats.validated / stats.total) * 100) : 0}%` },
        { 'Indicateur': 'Date d\'export', 'Valeur': new Date().toLocaleDateString('fr-FR') },
        { 'Indicateur': 'Heure d\'export', 'Valeur': new Date().toLocaleTimeString('fr-FR') }
      ];

      const workbook = XLSX.utils.book_new();
      const mainWorksheet = XLSX.utils.json_to_sheet(exportData);
      
      const colWidths = [
        { wch: 5 }, { wch: 12 }, { wch: 30 }, { wch: 40 }, { wch: 15 }, 
        { wch: 15 }, { wch: 12 }, { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 12 }
      ];
      mainWorksheet['!cols'] = colWidths;

      const statsWorksheet = XLSX.utils.json_to_sheet(statsData);
      statsWorksheet['!cols'] = [{ wch: 25 }, { wch: 20 }];

      XLSX.utils.book_append_sheet(workbook, mainWorksheet, 'Demandes');
      XLSX.utils.book_append_sheet(workbook, statsWorksheet, 'Statistiques');

      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:.]/g, '-');
      const filename = `demandes-validation-${timestamp}.xlsx`;

      XLSX.writeFile(workbook, filename);

      toast.success(`Export Excel réussi ! ${exportData.length} demandes exportées`, {
        position: 'top-right',
        autoClose: 500,
        icon: '📊'
      });

    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      toast.error('Erreur lors de l\'export Excel');
    } finally {
      setExporting(false);
    }
  };

return (
    <div className={`bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen ${isNavbarOpen ? 'lg:pl-64' : 'lg:pl-20'} transition-all duration-300`}>
      {/* Modal de retour fonctionnel - inchangé */}
      {showReturnModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-2xl"
          >
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <FiAlertTriangle className="text-red-600" size={20} />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">Raison du refus</h3>
            </div>
            <p className="text-gray-600 mb-4 text-sm">
              Veuillez saisir une raison pour refuser la demande <strong className="text-gray-800">"{selectedDemande?.ticket?.nom}"</strong>.
            </p>

            <textarea
              className="w-full border border-gray-300 rounded-lg px-4 py-3 mb-4 text-sm focus:outline-none focus:ring-2 focus:ring-red-300 focus:border-transparent resize-none"
              rows={4}
              placeholder="Saisissez la raison du refus..."
              value={causeText}
              onChange={(e) => setCauseText(e.target.value)}
              disabled={isProcessing}
            />

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => { setShowReturnModal(false); setCauseText(''); }}
                disabled={isProcessing}
                className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
              >
                Annuler
              </button>
              <button
                disabled={!causeText.trim() || isProcessing}
                onClick={handleConfirmReject}
                className={`px-4 py-2 text-white rounded-lg transition-colors duration-200 flex items-center gap-2 ${
                  causeText.trim() && !isProcessing
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-red-300 cursor-not-allowed"
                }`}
              >
                {isProcessing ? (
                  <>
                    <motion.div
                      className="w-4 h-4 border-2 border-white border-t-transparent rounded-full"
                      animate={{ rotate: 360 }}
                      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                    />
                    Traitement...
                  </>
                ) : (
                  "Confirmer le refus"
                )}
              </button>
            </div>
          </motion.div>
        </div>
      )}
      
      <div className="p-4 md:p-6 h-full flex flex-col">
        <ToastContainer 
          position="top-right" 
          autoClose={3000} 
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {/* Header avec breadcrumb */}
        <div className="mb-4 md:mb-6">
          <div className="flex items-center text-xs md:text-sm text-gray-600 mb-2 flex-wrap">
            <FiGlobe className="mr-1 md:mr-2" size={14} />
            <span>Gestion Globale</span>
            <span className="mx-1 md:mx-2">/</span>
            <span className="font-medium text-terrecuite-700">Validation des Demandes</span>
          </div>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-1">
                Centre de Validation
              </h1>
              <p className="text-gray-600 text-xs md:text-sm">
                Gérez et validez les demandes clients de toutes les régions
              </p>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              <button
                onClick={fetchDemandes}
                disabled={loading}
                className="flex items-center px-3 py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 text-xs md:text-sm"
              >
                <FiRefreshCw className={`mr-1 md:mr-2 ${loading ? 'animate-spin' : ''}`} size={12} />
                Actualiser
              </button>
              <button 
                onClick={handleExportExcel}
                disabled={exporting}
                className="flex items-center px-3 py-2 bg-terrecuite-600 text-white rounded-lg hover:bg-terrecuite-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-xs md:text-sm"
              >
                {exporting ? (
                  <>
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white mr-1 md:mr-2"></div>
                    Export...
                  </>
                ) : (
                  <>
                    <FiDownload className="mr-1 md:mr-2" size={12} />
                    Exporter
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Statistiques - version responsive */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-6">
          {[
            { 
              label: "Total", 
              value: stats.total, 
              icon: FiFileText, 
              color: "text-blue-600",
              bgColor: "bg-blue-100"
            },
            { 
              label: "En attente", 
              value: stats.pending, 
              icon: FiClock, 
              color: "text-orange-600",
              bgColor: "bg-orange-100"
            },
            { 
              label: "Validées", 
              value: stats.validated, 
              icon: FiCheckCircle, 
              color: "text-green-600",
              bgColor: "bg-green-100"
            },
            { 
              label: "Jours moyens", 
              value: stats.avgDays, 
              icon: FiCalendar, 
              color: "text-terrecuite-600",
              bgColor: "bg-terrecuite-100"
            }
          ].map((stat, index) => (
            <div key={index} className="bg-white rounded-lg p-3 shadow-sm border border-gray-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-gray-600 mb-1">{stat.label}</p>
                  <p className={`text-lg md:text-xl font-bold ${stat.color}`}>{stat.value}</p>
                </div>
                <div className={`p-2 ${stat.bgColor} rounded-full`}>
                  <stat.icon className={stat.color} size={16} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Filtres et recherche */}
        <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="md:col-span-2 relative">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={14} />
              <input
                type="text"
                placeholder="Rechercher par client, demande ou ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-terrecuite-300 focus:border-transparent text-sm"
              />
            </div>
            <div className="flex items-center gap-2">
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-terrecuite-300 focus:border-transparent text-sm"
              >
                <option value="id">Trier par: ID</option>
                <option value="client">Trier par: Client</option>
                <option value="demande">Trier par: Demande</option>
                <option value="jours">Trier par: Jours</option>
              </select>
              <button
                onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                title={`Tri ${sortOrder === 'asc' ? 'croissant' : 'décroissant'}`}
              >
                <FiFilter className={`transform ${sortOrder === 'desc' ? 'rotate-180' : ''} transition-transform text-gray-600`} size={14} />
              </button>
            </div>
          </div>
        </div>

        {/* Message d'erreur */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border-l-4 border-red-500 rounded-lg flex items-center">
            <FiAlertCircle className="text-red-500 mr-2 flex-shrink-0" size={14} />
            <span className="text-red-700 font-medium text-xs md:text-sm">{error}</span>
          </div>
        )}

        {/* Tableau principal - version responsive */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden flex-grow flex flex-col border border-gray-100">
          {loading ? (
            <div className="flex-grow flex flex-col items-center justify-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-4 border-gray-200 border-t-terrecuite-600 mb-3"></div>
              <p className="text-gray-600 font-medium text-sm">Chargement en cours...</p>
            </div>
          ) : filteredDemandes.length === 0 ? (
            <div className="flex-grow flex flex-col items-center justify-center p-8 text-center space-y-3">
              <div className="p-3 bg-gray-100 rounded-full">
                <FiFileText size={24} className="text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-700">
                {searchTerm ? 'Aucun résultat' : 'Aucune demande en attente'}
              </h3>
              <p className="text-gray-500 text-sm max-w-xs">
                {searchTerm 
                  ? 'Aucune demande ne correspond à votre recherche'
                  : 'Toutes les demandes sont traitées'
                }
              </p>
              {searchTerm ? (
                <button
                  onClick={() => setSearchTerm('')}
                  className="mt-3 px-4 py-2 bg-terrecuite-600 text-white rounded-lg hover:bg-terrecuite-700 transition-colors text-sm"
                >
                  Effacer la recherche
                </button>
              ) : (
                <button
                  onClick={refreshData}
                  className="mt-3 px-4 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors text-sm"
                >
                  Actualiser
                </button>
              )}
            </div>
          ) : (
            <>
              {/* En-tête du tableau */}
              <div className="bg-gray-50 border-b border-gray-200 hidden md:block">
                <div className="grid grid-cols-12 px-4 py-3 font-medium text-xs text-gray-600 uppercase tracking-wider">
                  <div className="col-span-1 flex items-center">ID</div>
                  <div className="col-span-3 flex items-center">Organisation</div>
                  <div className="col-span-4 flex items-center">Description</div>
                  <div className="col-span-2 flex items-center">Jours</div>
                  <div className="col-span-2 flex justify-center">Actions</div>
                </div>
              </div>

              {/* Corps du tableau */}
              <div className="divide-y divide-gray-100 overflow-y-auto flex-grow">
                {filteredDemandes.map((d) => (
                  <div key={d.id} className="block md:grid md:grid-cols-12 p-4 items-center text-sm hover:bg-gray-50/50 transition-colors duration-150">
                    {/* Version mobile - carte */}
                    <div className="md:hidden mb-3">
                      <div className="flex justify-between items-start mb-2">
                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-terrecuite-100 text-terrecuite-700">
                          #{d.id}
                        </span>
                        <div className="flex space-x-1">
                          <button
                            onClick={() => setSelectionnee(d)}
                            className="p-1 text-gray-400 hover:text-terrecuite-600 hover:bg-terrecuite-50 rounded transition-colors"
                            title="Voir les détails"
                          >
                            <FiEye size={14} />
                          </button>
                        </div>
                      </div>
                      
                      <div className="mb-3">
                        <p className="text-gray-900 font-medium text-sm">
                          {d.ticket.organisation.nomOrganisation}
                        </p>
                        <p className="text-gray-700 text-xs mt-1 font-medium">
                          {d.ticket.nom}
                        </p>
                        {d.ticket.description && (
                          <p className="text-gray-500 text-xs mt-1 line-clamp-2">
                            {d.ticket.description}
                          </p>
                        )}
                      </div>
                      
                      <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-2">
                          <span className="text-xs text-gray-600">Jours:</span>
                          <input
                            type="number"
                            min="0"
                            max="365"
                            placeholder={d.nbr_jrs?.toString() || '0'}
                            value={joursMap[d.id] || ''}
                            onChange={e => handleChangeJours(d.id, e.target.value)}
                            className="w-14 px-2 py-1 text-center border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-terrecuite-300"
                          />
                        </div>
                        
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleValider(d)}
                            disabled={!joursMap[d.id]}
                            className={`px-3 py-1 text-white rounded text-xs transition-colors flex items-center ${
                              joursMap[d.id] 
                                ? 'bg-green-500 hover:bg-green-600'
                                : 'bg-gray-300 cursor-not-allowed'
                            }`}
                            title="Valider la demande"
                          >
                            <FiCheck size={12} className="mr-1" />
                            Valider
                          </button>
                          <button
                            onClick={() => handleRefuser(d)}
                            className="px-3 py-1 bg-red-500 text-white rounded text-xs hover:bg-red-600 transition-colors flex items-center"
                            title="Refuser la demande"
                          >
                            <FiX size={12} className="mr-1" />
                            Refuser
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    {/* Version desktop - tableau */}
                    <div className="hidden md:grid md:col-span-1">
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-terrecuite-100 text-terrecuite-700">
                        #{d.id}
                      </span>
                    </div>
                    
                    <div className="hidden md:grid md:col-span-3">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                          <FiUser className="text-gray-600 text-xs" />
                        </div>
                        <div className="min-w-0">
                          <p className="text-gray-900 font-medium truncate text-sm">
                            {d.ticket.organisation.nomOrganisation}
                          </p>
                          <p className="text-gray-500 truncate text-xs">
                            {d.ticket.organisation.contactEmail || 'Email non renseigné'}
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="hidden md:grid md:col-span-4">
                      <div className="min-w-0">
                        <p className="text-gray-900 font-medium truncate text-sm" title={d.ticket.nom}>
                          {d.ticket.nom}
                        </p>
                        {d.ticket.description && (
                          <p className="text-gray-500 truncate text-xs mt-1">
                            {d.ticket.description}
                          </p>
                        )}
                      </div>
                    </div>
                    
                    <div className="hidden md:grid md:col-span-2">
                      <div className="flex items-center space-x-2">
                        <input
                          type="number"
                          min="0"
                          max="365"
                          placeholder={d.nbr_jrs?.toString() || '0'}
                          value={joursMap[d.id] || ''}
                          onChange={e => handleChangeJours(d.id, e.target.value)}
                          className="w-16 px-2 py-1 text-center border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-terrecuite-300"
                        />
                        <span className="text-xs text-gray-500">jours</span>
                      </div>
                    </div>
                    
                    <div className="hidden md:grid md:col-span-2">
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => setSelectionnee(d)}
                          className="p-1.5 text-gray-500 hover:text-terrecuite-600 hover:bg-gray-100 rounded transition-colors"
                          title="Voir les détails"
                        >
                          <FiEye size={16} />
                        </button>
                        <button
                          onClick={() => handleValider(d)}
                          disabled={!joursMap[d.id]}
                          className={`px-3 py-1.5 text-white rounded text-xs transition-colors flex items-center ${
                            joursMap[d.id] 
                              ? 'bg-green-500 hover:bg-green-600'
                              : 'bg-gray-300 cursor-not-allowed'
                          }`}
                          title="Valider la demande"
                        >
                          <FiCheck size={12} className="mr-1" />
                          Valider
                        </button>
                        <button
                          onClick={() => handleRefuser(d)}
                          className="px-3 py-1.5 bg-red-500 text-white rounded text-xs hover:bg-red-600 transition-colors flex items-center"
                          title="Refuser la demande"
                        >
                          <FiX size={12} className="mr-1" />
                          Refuser
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer du tableau */}
              <div className="bg-gray-50 px-4 py-3 border-t border-gray-200 flex items-center justify-between text-xs text-gray-600">
                <span>
                  Affichage de <span className="font-medium">1-{filteredDemandes.length}</span> sur {demandes.length} demandes
                </span>
                {searchTerm && (
                  <span className="bg-gray-100 px-3 py-1 rounded-full">
                    Filtre: "{searchTerm}"
                  </span>
                )}
              </div>
            </>
          )}
        </div>

        {/* Modal de détail */}
        <AnimatePresence>
          {selectionnee && (
            <DemandeDetail 
              demande={selectionnee} 
              onClose={() => setSelectionnee(null)} 
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default DemandeList;